import { TrainService } from './service/train.service';
import { ManageService } from './service/manage.service';
import { PredictService } from './service/predict.service';
import { DBConnectorService } from './service/test.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { InjectionToken, NgModule } from '@angular/core';
import { NvD3Module } from 'ng2-nvd3';
import { UserIdleModule } from 'angular-user-idle';
import { LoggedInGuard } from "./authentication/logged-in.guard";
import { DropzoneModule, DropzoneConfig, DropzoneConfigInterface, DropzoneDirective, DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  // Change this to your upload POST address:
  url: 'https:///post',
  // acceptedFiles: '*.xlsx',
  createImageThumbnails: true
};
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { LayoutComponent } from './layout/layout.component';
import { HomeComponent } from './home/home.component';
import { TrainComponent } from './train/train.component';
import { PredictComponent } from './predict/predict.component';
import { ManageUserComponent } from './manage-user/manage-user.component';
import { ConfigComponent } from './config/config.component';
import { RulesComponent } from './config/rules/rules.component';
import { ExceptionsComponent } from './config/exceptions/exceptions.component';
import { UsersComponent } from './manage-user/users/users.component';
import { SectorsComponent } from './manage-user/sectors/sectors.component';
import { ModelsComponent } from './manage-user/models/models.component';
import { LabelsComponent } from './manage-user/labels/labels.component';
import { BackupComponent } from './manage-user/backup/backup.component';
import { UpdateComponent } from './home/update/update.component';
import { AppRoutingModule } from './app-routing.module';
import { Step2Component } from './train/step2/step2.component';
import { Step2newdataComponent } from './train/step2newdata/step2newdata.component';
import { Step3Component } from './train/step3/step3.component';
import { Step3DoneComponent } from './train/step3-done/step3-done.component';
import { Step3newdataComponent } from './train/step3newdata/step3newdata.component';
import { PredictUsingExcelComponent } from './predict/predict-using-excel/predict-using-excel.component';
import { InstantPredictComponent } from './predict/instant-predict/instant-predict.component';
import { ConfirmdeleteComponent } from './service/confirmdelete/confirmdelete.component';
import { ViewExcelModalComponent } from './manage-user/backup/view-excel-modal/view-excel-modal.component';
import { ViewLabelmappingModalComponent } from './manage-user/backup/view-labelmapping-modal/view-labelmapping-modal.component';
import { NouserComponent } from './nouser/nouser.component';
import { EditUserComponent } from './manage-user/users/edit-user/edit-user.component';
import { ShowLogDialogComponent } from './show-log-dialog/show-log-dialog.component';
import { AuthService } from '../app/service/auth.service';

import { LogComponent } from './manage-user/log/log.component';
import { LoaderComponent } from './loader/loader.component';
import { TrainxlsComponent } from './train/trainwithxls/trainwithxls.component';
import { TimeoutComponent } from './nouser/timeout/timeout.component';
import { UnAuthorizedComponent } from './nouser/unauthorized/unauthorized.component';
import { LogService } from './service/log.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MsalModule, MsalService, MSAL_INSTANCE, MsalInterceptorConfiguration, MSAL_INTERCEPTOR_CONFIG, MsalGuard, MsalInterceptor } from '@azure/msal-angular';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';

import { msalConfigProps } from '../environments/environment';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: msalConfigProps.clientId,
      redirectUri: msalConfigProps.redirectUri,
      authority: `${msalConfigProps.authority}${msalConfigProps.tenant}`
    }
  })
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  protectedResourceMap.set(msalConfigProps.apiPath, [msalConfigProps.apiScope]);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

export const APP_CONFIG_TOKEN = new InjectionToken<string>('APP_CONFIG_TOKEN');

export function appConfigFactory() {
  return (window as any).APP_CONFIG;
}

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        LogoutComponent,
        LayoutComponent,
        HomeComponent,
        TrainComponent,
        PredictComponent,
        ManageUserComponent,
        ConfigComponent,
        RulesComponent,
        ExceptionsComponent,
        UsersComponent,
        SectorsComponent,
        ModelsComponent,
        LabelsComponent,
        BackupComponent,
        UpdateComponent,
        Step2Component,
        Step2newdataComponent,
        Step3Component,
        Step3DoneComponent,
        Step3newdataComponent,
        PredictUsingExcelComponent,
        InstantPredictComponent,
        ConfirmdeleteComponent,
        ViewExcelModalComponent,
        ViewLabelmappingModalComponent,
        NouserComponent,
        EditUserComponent,
        UnAuthorizedComponent,
        LoaderComponent,
        LogComponent,
        TrainxlsComponent,
        TimeoutComponent,
        ShowLogDialogComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        NvD3Module,
        DropzoneModule,
        MsalModule,
        ModalModule.forRoot(),
        UserIdleModule.forRoot({ idle: 3600, timeout: 3, ping: 3600 })
    ],
    providers: [DBConnectorService,
        PredictService,
        ManageService,
        TrainService,
        LoggedInGuard,
        AuthService,
        LogService,
        MsalService,
        MsalGuard,
        { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
        { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
        { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },    
        { provide: DROPZONE_CONFIG, useValue: DEFAULT_DROPZONE_CONFIG },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: APP_CONFIG_TOKEN, useFactory: appConfigFactory }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }

